export default __webpack_public_path__ + "images/a746671152000d656219183b9005f20e.png";